import enableInboxRuleRequest from 'owa-service/lib/factory/enableInboxRuleRequest';
import enableInboxRuleOperation from 'owa-service/lib/operation/enableInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Helper method that creates the EnableInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleRequest
 */
function createRequestBody(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = enableInboxRuleRequest({
        Header: getJsonRequestHeader(),
        Identity: inboxRule.Identity,
    });
    requestBody.Force = force;
    requestBody.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
    return requestBody;
}
/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
export default function enableInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = createRequestBody(inboxRule, force, alwaysDeleteOutlookRulesBlob);
    return enableInboxRuleOperation(requestBody);
}
//# sourceMappingURL=enableInboxRuleService.js.map